import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import type {
  CounselingCenterMeasureStatistic,
  CounselingCenterStatistics,
} from '../../../common/types/statistics/fhbfStatistics';

type Props = {
  statistics: CounselingCenterStatistics;
};

const statisticsOrder: {
  key: keyof CounselingCenterMeasureStatistic;
  label: string;
}[] = [
  {
    key: 'totalNumberOfMeasures',
    label: 'Gesamtzahl der Beratungen',
  },
  {
    key: 'durationUnderSixtyMinutes',
    label: 'Dauer unter 60 Minuten',
  },
  {
    key: 'durationOverSixtyMinutes',
    label: 'Dauer über 60 Minuten',
  },
  {
    key: 'numberOfTypeTelephoneConsultation',
    label: 'Anzahl telefonischer Beratungen',
  },
  {
    key: 'numberOfTypePersonalConsultation',
    label: 'Anzahl persönlicher Beratungen',
  },
  {
    key: 'numberOfTypeAccompaniment',
    label: 'Anzahl Begleitungen',
  },
  {
    key: 'numberOfTypeOnlineConsultation',
    label: 'Anzahl Onlineberatungen',
  },
  {
    key: 'numberOfTopicDomesticViolence',
    label: 'Anzahl der Beratungen zu häuslicher Gewalt',
  },
  {
    key: 'numberOfTopicStalking',
    label: 'Anzahl der Beratungen zu Stalking',
  },
  {
    key: 'numberOfTopicBullying',
    label: 'Anzahl der Beratungen zu Mobbing',
  },
  {
    key: 'numberOfTopicFgm',
    label: 'Anzahl der Beratungen zu FGM',
  },
  {
    key: 'numberOfTopicPsychosocialCounseling',
    label: 'Anzahl der psychosozialen Beratungen',
  },
  {
    key: 'numberOfTopicTraumaCounseling',
    label: 'Anzahl der Traumafachberatungen',
  },
  {
    key: 'numberOfTopicOther',
    label: 'Anzahl der Beratungen zu sonstigen Themen',
  },
  {
    key: 'numberOfTranslation',
    label: 'Dolmetscherdienst',
  },
  {
    key: 'numberOfRiskQuestionnaire',
    label: 'Risikofragebogen',
  },
  {
    key: 'numberOfAppointmentDidNotTakePlace',
    label: 'Termin hat trotz Vereinbarung nicht stattgefunden',
  },
];

function MeasureStatistics({ statistics }: Props) {
  return (
    <Stack direction='column'>
      <Typography fontWeight='bold'>Beruntungsgespräche</Typography>
      {statisticsOrder.map(({ key, label }) => (
        <Typography key={key}>
          {label}: {statistics[key]}
        </Typography>
      ))}
      <Typography>Anzahl der Kurzkontake: {statistics.numberOfContactAttempts}</Typography>
      <Typography fontWeight='bold' mt={2}>
        Anzahl der Frauen mit x Beratungsterminen
      </Typography>
      <Typography>1 Beratungstermin: {statistics.numberOfWomenWithOneMeasure}</Typography>
      <Typography>2 Beratungstermine: {statistics.numberOfWomenWithTwoMeasures}</Typography>
      <Typography>3 Beratungstermine: {statistics.numberOfWomenWithThreeMeasures}</Typography>
      <Typography>4 Beratungstermine: {statistics.numberOfWomenWithFourMeasures}</Typography>
      <Typography>5 Beratungstermine und mehr: {statistics.numberOfWomenWithFiveAndMoreMeasures}</Typography>
    </Stack>
  );
}

export default MeasureStatistics;
